module.exports = __webpack_public_path__ + "img/steam-engine-H-shadow.6d6f992a.png";